import { httpNFR, http } from "../http-common";

const captureActivity = (action, utcTime) => {
  let url = `audit-report/capture-activity?action=${action}`;
  if (utcTime !== undefined) {
    url += `&actionDate=${utcTime}`;
  }
  return http.post(url);
};

const getLevel0Data = (params, config = {}) => {
  return http.get(`audit-report/level0`, {
    params,
    ...config,
  });
};

const getLevel0ExportData = (params, config = {}) => {
  return http.get(`audit-report/level0-export`, {
    params,
    ...config,
  });
};

const getLevel1Data = (params, config = {}) => {
  return http.get(`audit-report/level1`, {
    params,
    ...config,
  });
};

const getLevel1ExportData = (params, config = {}) => {
  return http.get(`audit-report/level1-export`, {
    params,
    ...config,
  });
};

const ReportService = {
  captureActivity,
  getLevel0Data,
  getLevel0ExportData,
  getLevel1Data,
  getLevel1ExportData,
};

export default ReportService;
